class InstallmentCalculator {
  /**
   * 원리금 균등 상환 계산
   */
  static calculateLoan(pm_released_price, ps_price, dealer_subsidy, period) {
    // 할부원금 계산
    const principal = this.#calcInstallmentAmount(
      pm_released_price,
      ps_price,
      dealer_subsidy,
    );

    // 월 이자율 계산
    const monthlyInterestRate = 0.00492; // 0.492%

    // 월 상환금 계산
    const monthlyPayment = this.#calculateMonthlyPayment(
      principal,
      monthlyInterestRate,
      period,
    );

    // 상환 스케줄 및 총 이자 계산
    const schedule = this.#generateSchedule(
      principal,
      monthlyInterestRate,
      period,
      monthlyPayment,
    );

    // 총 이자 계산
    const totalInterest = schedule.reduce(
      (sum, month) => sum + month.interest,
      0,
    );

    return {
      installmentAmount: Math.round(principal),
      monthlyPayment: Math.round(monthlyPayment),
      totalInterest: Math.round(totalInterest),
    };
  }

  /**
   * 할부원금 계산
   */
  static #calcInstallmentAmount(pm_released_price, ps_price, dealer_subsidy) {
    // 할부원금: (출고가 - (공시지원금 + 매장지원금))
    return pm_released_price - (ps_price + dealer_subsidy);
  }

  /**
   * 월 상환금 계산
   * @private
   */
  static #calculateMonthlyPayment(
    principal,
    monthlyInterestRate,
    termInMonths,
  ) {
    if (termInMonths === 0) {
      return principal;
    }

    // 원리금 균등상환 공식
    // P * r * (1 + r)^n / ((1 + r)^n - 1)
    // P: 원금, r: 월이율, n: 기간(월)
    return (
      (principal *
        monthlyInterestRate *
        Math.pow(1 + monthlyInterestRate, termInMonths)) /
      (Math.pow(1 + monthlyInterestRate, termInMonths) - 1)
    );
  }

  /**
   * 월별 상환 스케줄 생성
   * @private
   */
  static #generateSchedule(
    principal,
    monthlyInterestRate,
    termInMonths,
    monthlyPayment,
  ) {
    const schedule = [];
    let remainingBalance = principal;

    for (let month = 1; month <= termInMonths; month++) {
      remainingBalance =
        schedule[month - 2]?.remainingBalance ?? remainingBalance;

      // 이자 계산
      const interest = remainingBalance * monthlyInterestRate;

      // 원금 계산
      const principalPayment = monthlyPayment - interest;

      // 잔액 갱신
      remainingBalance -= principalPayment;

      schedule.push({
        month,
        interest,
        remainingBalance: Math.max(0, remainingBalance),
      });
    }
    return schedule;
  }
}

module.exports = {
  InstallmentCalculator: InstallmentCalculator,
};
